export default __webpack_public_path__ + "static/B0089-ce36463dbe8eab7d121c0c23d32abd1f.png";